import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


import React, { useState } from "react";

const SortIcons = ({ label, field, orderBy, sortOrder, onAscClick, onDescClick }) => {
  const handleLabelClick = () => {
      if (orderBy !== field || sortOrder === "desc") {
        onAscClick && onAscClick();
      } else if (sortOrder === "asc") {
        onDescClick && onDescClick();
    }
  };

  return (
    <span style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
      <span onClick={handleLabelClick} style={{ fontWeight: orderBy === field ? "bold" : "normal" }}>
        {label}
      </span>
      <span style={{ marginLeft: "4px" }}>
        <span
          style={{
            cursor: "pointer",
            padding: 0,
            margin: 0,
            height: "5px",
            display: "flex",
            alignItems: "center",
            color: orderBy === field && sortOrder === 'asc' ? '#ff5252' : '#aaaaaaff',
          }}
          onClick={(e) => {
            e.stopPropagation();
            onAscClick();
          }}
          title="Sort Ascending"
        >
          <ArrowDropUpIcon fontSize="small" />
        </span>
        <span
          style={{
            cursor: "pointer",
            padding: 0,
            margin: 0,
            height: "5px",
            display: "flex",
            alignItems: "center",
            color: orderBy === field && sortOrder === 'desc' ? '#ff5252' : '#aaaaaaff',
          }}
          onClick={(e) => {
            e.stopPropagation();
            onDescClick();
          }}
          title="Sort Descending"
        >
          <ArrowDropDownIcon fontSize="small" />
        </span>
      </span>
    </span>
  );
};

export default SortIcons;